const config = {
  apiGateway: {
    REGION: 'us-west-2',
    PHY_LOCATION_APIGATEWAY_URL: 'https://1lox8sl782.execute-api.us-west-2.amazonaws.com/prod',
    INTERNAL_PHY_LOCATION_APIGATEWAY_URL: 'https://25tkmw29k4.execute-api.us-west-2.amazonaws.com/prod',
    COMPANY_APIGATEWAY_URL: 'https://kty0q8loa7.execute-api.us-west-2.amazonaws.com/prod',
  },
  reactApp: {
    VERSION: 'taxonomy-physical-location-1.16.5',
    HOSTNAME: 'https://locations.uat.forwood.one'
  },
  configurationService: {
    URL: 'https://config.uat.forwood.one',
    WEBSOCKET: 'wss://30xjv1z799.execute-api.us-west-2.amazonaws.com/prod'
  },
};

export default config;